import { c } from 'react-compiler-runtime';
import styled from 'styled-components';
import { get } from '../../constants.js';
import { jsx } from 'react/jsx-runtime';

const StyledDivider = styled.div.withConfig({
  displayName: "Divider__StyledDivider",
  componentId: "sc-1s7tlfq-0"
})(["height:1px;background:", ";margin-top:calc(", " - 1px);margin-bottom:", ";"], get('colors.border.muted'), get('space.2'), get('space.2'));

/**
 * Visually separates `Item`s or `Group`s in an `ActionList`.
 */
function Divider() {
  const $ = c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/jsx(StyledDivider, {});
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

/**
 * `Divider` fulfills the `ItemPropsWithCustomRenderer` contract,
 * so it can be used inline in an `ActionList`’s `items` prop.
 * In other words, `items={[ActionList.Divider]}` is supported as a concise
 * alternative to `items={[{renderItem: () => <ActionList.Divider />}]}`.
 */
Divider.renderItem = Divider;

export { Divider, StyledDivider };
